var origin = window.location.origin + '/';
jQuery(document).ready(function($) {
    if ($('.grid').length) {
        // var $grid = $('.grid').masonry({
        //     itemSelector: '.grid-item',
        //     gutter: 15
        // });

        $('.grid').masonry({
            itemSelector: '.grid-item',
            gutter: 15
        }); 

        // Get an array of all image elements in the grid
        var $images = $('.grid').find('img');

        // Create a new imagesLoaded instance for the grid
        var imgLoad = imagesLoaded('.grid');

        // When all images have finished loading, initialize Masonry layout
        imgLoad.on('done', function() {
            console.log('images loaded');
            $('.grid').masonry({ 
                itemSelector: '.grid-item',
                gutter: 15
            });
            adjustLayout();
        });

        //on scroll
        $(window).scroll(function() {
            adjustLayout();
        });

        // Update the layout on progress
        imgLoad.on('progress', function() {
            $('.grid').masonry('layout');
        });

        // Pre-load each image using JavaScript
        $images.each(function(index, element) {
            var image = new Image();
            image.onload = function() {
                // When the image has finished loading, set the src attribute and width
                element.src = image.src;
                element.style.width = image.naturalWidth + 'px';
            };
            image.src = element.getAttribute('data-src');
            adjustLayout();
        });

        function checkOverlap($gridItems) {
            let hasOverlap = false;
            $gridItems.each(function (index, element) {
                $gridItems.each(function (innerIndex, innerElement) {
                    if (index !== innerIndex) {
                        const rect1 = element.getBoundingClientRect();
                        const rect2 = innerElement.getBoundingClientRect();
                        const overlap = !(rect1.right <= rect2.left || 
                                          rect1.left >= rect2.right || 
                                          rect1.bottom <= rect2.top || 
                                          rect1.top >= rect2.bottom);
        
                        if (overlap) {
                            hasOverlap = true;
                            return false; // break the loop
                        }
                    }
                });
        
                if (hasOverlap) {
                    return false; // break the loop
                }
            });
        
            return hasOverlap;
        }
        
        function adjustLayout() {
            const $gridItems = $('.grid-item');
        
            // Check for overlaps and adjust the layout
            if (checkOverlap($gridItems)) {
                console.log('Overlap detected. Reloading the layout.');
                $('.grid').masonry('reloadItems');
                $('.grid').masonry('layout');
            }
        }


        // // layout Masonry after each image loads
        // $grid.imagesLoaded().progress( function() {
        //     $grid.masonry('layout');
        // });

        //if user scrolls 500 pixels from top reload masonry
        // $(window).scroll(function() {
        //     let ranOnce = false;
        //     if (ranOnce) {
        //         return;
        //     }
        //     if($(window).scrollTop() > 500) {
        //         $grid.masonry('reloadItems');
        //         ranOnce = true;
        //     }
        // });

    }
    
    console.log('test');

    if ($('.blog-masonry').length) {
        var $grid = $('.blog-masonry').masonry({
            itemSelector: '.grid-item',
            gutter: 15
        });
        // layout Masonry after each image loads
        $grid.imagesLoaded().progress( function() {
            $grid.masonry('layout');
        });

        //if user scrolls 500 pixels from top reload masonry
    //     $(window).scroll(function() {
    //         let ranOnce = false;
    //         if (ranOnce) {
    //             return;
    //         }
    //         if($(window).scrollTop() > 500) {
    //             $grid.masonry('reloadItems');
    //             ranOnce = true;
    //         }
    //     });

    //     //add event listener for each img in masonry grid to reload masonry when loaded
    //     $('.blog-masonry img').each(function() {
    //         $(this).on('load', function() {
    //             $grid.masonry('layout');
    //         });
    //     });
    }

    //gallery video interactivity
    $('.video').click(function() {
        if($(this).children('.custom-video').get(0).paused) {
            $(this).children('.custom-video').trigger('play');
            $(this).children('.gallery-video__play-button').fadeOut();
        }
        else {
            $(this).children('.custom-video').trigger('pause');
            $(this).children('.gallery-video__play-button').fadeIn();
        }
    });


    //setup slick slider if mobile-info-bar exists
    if($('.mobile-info-bar').length && window.innerWidth < 577) {
        $('.mobile-info-bar').slick({
            dots: true,
            infinite: true,
            slidesToShow: 1,
            adaptiveHeight: true,
            arrows: false
        });
    }

    if($('.shopify-section--custom-testimonials').length ) {
        $('.testimonial-slider').slick({
            dots: true,
            infinite: true,
            slidesToShow: 1,
            adaptiveHeight: true,
            arrows: true,
            fade: true,
            // cssEase:'linear',
            speed:'500',
            prevArrow: `<svg class='previous slick-arrow' width="57" height="100" viewBox="0 0 57 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_123_798)">
              <path d="M50.0004 -0.000106812C51.3252 -0.000274658 52.6204 0.392464 53.722 1.12843C54.8237 1.86441 55.6823 2.91055 56.1893 4.13454C56.6963 5.35854 56.829 6.70542 56.5705 8.00481C56.312 9.30421 55.6739 10.4977 54.737 11.4345L16.1704 50.0001L54.737 88.5658C55.9932 89.822 56.699 91.5258 56.699 93.3024C56.699 94.1821 56.5257 95.0531 56.1891 95.8658C55.8524 96.6785 55.359 97.417 54.737 98.039C54.115 98.661 53.3765 99.1544 52.5638 99.4911C51.7511 99.8277 50.8801 100.001 50.0004 100.001C48.2238 100.001 46.52 99.2952 45.2638 98.039L1.9615 54.7367C0.705494 53.4804 -9.15527e-05 51.7766 -9.15527e-05 50.0001C-9.15527e-05 48.2236 0.705494 46.5199 1.9615 45.2635L45.2638 1.96126C45.8853 1.33858 46.6236 0.84478 47.4365 0.508202C48.2493 0.171616 49.1206 -0.00112915 50.0004 -0.000106812Z" fill="#8A0FCE"></path>
            </g>
            <defs>
              <clipPath id="clip0_123_798">
                <rect width="56.6987" height="100" fill="white" transform="translate(56.6982 100) rotate(-180)"></rect>
              </clipPath>
            </defs>
          </svg>`,
            nextArrow: `<svg class='next slick-arrow' width="57" height="100" viewBox="0 0 57 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_123_796)">
              <path d="M6.69786 100C5.373 100 4.07785 99.6075 2.97622 98.8716C1.87458 98.1356 1.01595 97.0895 0.508926 95.8655C0.00190182 94.6415 -0.13074 93.2946 0.127773 91.9952C0.386287 90.6958 1.02435 89.5023 1.96125 88.5655L40.5278 49.9999L1.96125 11.4342C0.705019 10.178 -0.000721927 8.47418 -0.000721927 6.6976C-0.000721927 5.81793 0.172542 4.94688 0.509177 4.13417C0.845812 3.32146 1.33923 2.58301 1.96125 1.96099C2.58327 1.33897 3.32172 0.845558 4.13443 0.508923C4.94713 0.172287 5.81819 -0.000976562 6.69786 -0.000976562C8.47444 -0.000976562 10.1782 0.704764 11.4345 1.96099L54.7367 45.2633C55.9927 46.5196 56.6983 48.2234 56.6983 49.9999C56.6983 51.7764 55.9927 53.4801 54.7367 54.7365L11.4345 98.0387C10.813 98.6614 10.0746 99.1552 9.26176 99.4918C8.44893 99.8284 7.57762 100.001 6.69786 100Z" fill="#8A0FCE"></path>
            </g>
            <defs>
              <clipPath id="clip0_123_796">
                <rect width="56.6987" height="100" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>`,
          responsive: [
            {
                breakpoint: 741,
                settings: {
                    arrows: false
                }
            }
        ]
        });
    }

    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };    

    function initializeSlick() {
        $('.image-slider').slick({
            dots: false,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: 3500,
            arrows: true,
            prevArrow: `<svg class='previous slick-arrow' width="57" height="100" viewBox="0 0 57 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_123_798)">
            <path d="M50.0004 -0.000106812C51.3252 -0.000274658 52.6204 0.392464 53.722 1.12843C54.8237 1.86441 55.6823 2.91055 56.1893 4.13454C56.6963 5.35854 56.829 6.70542 56.5705 8.00481C56.312 9.30421 55.6739 10.4977 54.737 11.4345L16.1704 50.0001L54.737 88.5658C55.9932 89.822 56.699 91.5258 56.699 93.3024C56.699 94.1821 56.5257 95.0531 56.1891 95.8658C55.8524 96.6785 55.359 97.417 54.737 98.039C54.115 98.661 53.3765 99.1544 52.5638 99.4911C51.7511 99.8277 50.8801 100.001 50.0004 100.001C48.2238 100.001 46.52 99.2952 45.2638 98.039L1.9615 54.7367C0.705494 53.4804 -9.15527e-05 51.7766 -9.15527e-05 50.0001C-9.15527e-05 48.2236 0.705494 46.5199 1.9615 45.2635L45.2638 1.96126C45.8853 1.33858 46.6236 0.84478 47.4365 0.508202C48.2493 0.171616 49.1206 -0.00112915 50.0004 -0.000106812Z" fill="#FAFAFA"></path>
            </g>
            <defs>
            <clipPath id="clip0_123_798">
                <rect width="56.6987" height="100" fill="white" transform="translate(56.6982 100) rotate(-180)"></rect>
            </clipPath>
            </defs>
        </svg>`,
            nextArrow: `<svg class='next slick-arrow' width="57" height="100" viewBox="0 0 57 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_123_796)">
            <path d="M6.69786 100C5.373 100 4.07785 99.6075 2.97622 98.8716C1.87458 98.1356 1.01595 97.0895 0.508926 95.8655C0.00190182 94.6415 -0.13074 93.2946 0.127773 91.9952C0.386287 90.6958 1.02435 89.5023 1.96125 88.5655L40.5278 49.9999L1.96125 11.4342C0.705019 10.178 -0.000721927 8.47418 -0.000721927 6.6976C-0.000721927 5.81793 0.172542 4.94688 0.509177 4.13417C0.845812 3.32146 1.33923 2.58301 1.96125 1.96099C2.58327 1.33897 3.32172 0.845558 4.13443 0.508923C4.94713 0.172287 5.81819 -0.000976562 6.69786 -0.000976562C8.47444 -0.000976562 10.1782 0.704764 11.4345 1.96099L54.7367 45.2633C55.9927 46.5196 56.6983 48.2234 56.6983 49.9999C56.6983 51.7764 55.9927 53.4801 54.7367 54.7365L11.4345 98.0387C10.813 98.6614 10.0746 99.1552 9.26176 99.4918C8.44893 99.8284 7.57762 100.001 6.69786 100Z" fill="#FAFAFA"></path>
            </g>
            <defs>
            <clipPath id="clip0_123_796">
                <rect width="56.6987" height="100" fill="white"></rect>
            </clipPath>
            </defs>
        </svg>`,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
        });
    }

    if($('.shopify-section--custom-image-slider').length ) {
        initializeSlick();
    }

    var reinitializeSlick = debounce(function() {
        $('.image-slider').slick('unslick');  // Unslick/destroy the current slick slider
        initializeSlick();  // Reinitialize slick
    }, 250);
    
    $(window).resize(reinitializeSlick);
    
    $('.custom-video').on('ended', function() {
        $(this).siblings('.gallery-video__play-button').fadeIn();
    });

    if ($('#contact_form select').length) {
        $('select').on('change', function() {
            if ($(this).val() === 'Technical Support') {
              $('.note').css({display: 'block'});
            } else {
              $('.note').css({display: 'none'});
            }
          });
    }

    if($('.promotion-block').length) {
        $('.promotion-block').click(function() {
            if($(this).hasClass('show')) {
                $(this).removeClass('show');
            }
            else {
                $('.promotion-block').removeClass('show');
                $(this).addClass('show');
            }
        })
    }

    $('.tab').click(function() {
        let tab_number = $(this).attr('data-tab-number');
        $('.tab').removeClass('active');
        $('.tab-content').removeClass('active');

        $(this).addClass('active');
        $('.tab-content[data-content-number="' + tab_number + '"]').addClass('active');
    });

    // document.querySelectorAll('.block-swatch').forEach(function(swatch) {
    //     swatch.addEventListener('click', function() {
    //         let buttonIndex = [...swatch.parentNode.children].indexOf(swatch);
    //         console.log(buttonIndex);
    //         if(buttonIndex === 0) {
    //             // first button clicked
    //             let productMediaItems = document.querySelectorAll('.product__media-item');
    //             productMediaItems.forEach(function(item) {
    //                 item.classList.remove('hide');
    //             });
    //             let productThumbItems = document.querySelectorAll('.product__thumbnail-item');
    //             productThumbItems.forEach(function(item) {
    //                 item.classList.remove('hide');
    //             });
    //             let variantSlider1 = document.querySelectorAll('*[data-variant-slider-1="hide"]');
    //             variantSlider1.forEach(function(item) {
    //                 item.classList.add('hide');
    //             });
    //             document.querySelectorAll('.product__thumbnail-item')[0].click();

    //             console.log('first button clicked');
    //         }
    //         else {
    //             // second button clicked
    //             let productMediaItems = document.querySelectorAll('.product__media-item');
    //             productMediaItems.forEach(function(item) {
    //                 item.classList.add('hide');
    //             });
    //             let productThumbItems = document.querySelectorAll('.product__thumbnail-item');
    //             productThumbItems.forEach(function(item) {
    //                 item.classList.add('hide');
    //             });
    //             let variantSlider1 = document.querySelectorAll('*[data-variant-slider-1="hide"]');
    //             variantSlider1.forEach(function(item) {
    //                 item.classList.remove('hide');
    //             });
    //             document.querySelectorAll('.product__thumbnail-item[data-variant-slider-1="hide"]')[0].click();
    //             console.log('second button clicked');
    //         }
    //         let flickityCarousel = document.querySelector('flickity-carousel');
    //         flickityCarousel.reload();
    //     });
    // });

    //scroll to for the page review area
    function scrollToSection(sectionId) {

        setTimeout(() => {
            // Select the section with the specified ID
            var section = document.getElementById(sectionId);
            console.log(section);
            if (section) {
               //Scroll to the section
                section.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
            }
        }, 3000);
    }

    //image grid modal
    let $galleryImages = $('.gallery-image');
    let modalIndex = 0;

    function showModalImage(index) {
        modalIndex = (index + $galleryImages.length) % $galleryImages.length;
        $('#modal-image').attr('src', $galleryImages.eq(modalIndex).attr('src'));
    }

    $galleryImages.click(function() {
        $('#modal').addClass('active');
        $('#modal-background').addClass('active');
        showModalImage($galleryImages.index(this));
    });

    $('#modal-background').click(function() {
        $('#modal').removeClass('active');
        $('#modal-background').removeClass('active');
    });

    //desktop prev/next arrows
    $('#modal-prev').click(function(e) {
        e.stopPropagation(); // don't let the click reach the background and close the modal
        showModalImage(modalIndex - 1);
    });

    $('#modal-next').click(function(e) {
        e.stopPropagation();
        showModalImage(modalIndex + 1);
    });

    //store page product cards: show the hover image on tap while the product page loads
    $('.product-cards .product-card').click(function() {
        $(this).addClass('tapped');
    });

    //clear it if the page is restored from the back/forward cache
    $(window).on('pageshow', function() {
        $('.product-card.tapped').removeClass('tapped');
    });

    //left/right arrow keys while the modal is open
    $(document).on('keydown', function(e) {
        if (!$('#modal-background').hasClass('active')) return;
        if (e.key === 'ArrowLeft') showModalImage(modalIndex - 1);
        if (e.key === 'ArrowRight') showModalImage(modalIndex + 1);
    });

    //swipe left/right in the modal for next/prev image
    let touchStartX = 0;
    let touchStartY = 0;

    $('#modal-background').on('touchstart', function(e) {
        touchStartX = e.originalEvent.touches[0].clientX;
        touchStartY = e.originalEvent.touches[0].clientY;
    });

    $('#modal-background').on('touchend', function(e) {
        let dx = e.originalEvent.changedTouches[0].clientX - touchStartX;
        let dy = e.originalEvent.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            e.preventDefault(); // don't let the swipe count as a tap-to-close
            showModalImage(modalIndex + (dx < 0 ? 1 : -1));
        }
    });


    if (window.location.hash === '#reviews') {
      // check if target element exists
      let checkExists = setInterval(function() {
        const targetElement = document.querySelector('#hc-product-tabs');
        console.log(targetElement);
        if (targetElement) {
          clearInterval(checkExists);
        //get offset of target element and minus 150 and scroll to that position
            const targetOffset = targetElement.offsetTop - 300;
            window.scrollTo({
                top: targetOffset,
                behavior: 'smooth'
            });
        }
      }, 1000);
    }

    //on page scroll down add a class of solid to the shopify-section--header class
    $(window).scroll(function() {
        // console.log(window.location.href)
        if ($(document).scrollTop() == 0) {
            if(window.location.href != origin || window.location.href.includes('all-products') || window.location.href.includes('products')) {
                $('.shopify-section--header').addClass('solid');
                // console.log("add solid")
            }
            else {
                if(!window.location.href.includes('products')) {
                    $('.shopify-section--header').removeClass('solid');
                    //console.log('else');
                    // console.log("remove solid")
                }
            }
        }
        else if ($(document).scrollTop() > 50) {
            $('.shopify-section--header').addClass('solid');
        } else {
            if(window.location.href != origin) {
                $('.shopify-section--header').addClass('solid');
            }
            else {
                $('.shopify-section--header').removeClass('solid');
                //console.log('else non origin');
            }
    
        }
    });
    //on load if the url contains ?v=stand then click .custom-ajax-button that has text Stand
    if(window.location.href.includes('?v=stand')) {
        $('.custom-ajax-button:contains("Stand")').click();
    }
    setTimeout(function() {
        //if .grid exists
        let grid = document.querySelector(".grid");
        if (grid) {
            console.log(grid);
          //reload and resize masonry to make sure spacing is good
          grid.masonry("reloadItems");
        }
    }, 5000);


    //find .header__icon-wrapper with href "/cart" and aria-label="Cart" and event listener for click
    $('.header__icon-wrapper[href="/cart"][aria-label="Cart"]').click(function(e) {
        //prevent default
        e.preventDefault();
        //go to /cart
        window.location.href = "/cart";
    });

    console.log('hyperspeed cache test custom-theme.js 2');

    if(document.querySelector('.cart-addons')) {
        document.querySelectorAll('.cart-addon-item__add-button').forEach(function(button) {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                
                const variantId = this.getAttribute('data-variant-id');
                const productTitle = this.getAttribute('data-product-title');
                const buttonText = this.querySelector('.cart-addon-item__add-text');
                const loadingSpinner = this.querySelector('.cart-addon-item__loading');
                
                button.disabled = true;
                buttonText.style.display = 'none';
                loadingSpinner.style.display = 'inline-block';
                
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    // AglowGeo add-ons carry the same "Note" property as the product page's Add to cart, so checkout shows it
                    body: JSON.stringify(Object.assign({
                        id: variantId,
                        quantity: 1
                    }, button.dataset.note ? { properties: { Note: button.dataset.note } } : {}))
                })
                .then(response => response.json())
                .then(data => {
                    buttonText.textContent = button.dataset.addedText || 'Added!';
                    buttonText.style.display = 'inline';
                    loadingSpinner.style.display = 'none';
                    
                    fetch('/cart.js')
                        .then(response => response.json())
                        .then(cart => {
                            const cartCount = document.querySelector('.header__cart-count');
                            if(cartCount) {
                                cartCount.textContent = cart.item_count;
                            }
                            
                            const cartTotal = document.querySelector('.cart__total-container .heading:last-child');
                            if(cartTotal) {
                                cartTotal.textContent = Shopify.formatMoney(cart.total_price, theme.moneyFormat);
                            }
                        });
                    
                    setTimeout(function() {
                        window.location.reload();
                    }, 800);
                })
                .catch(error => {
                    console.error('Error adding to cart:', error);
                    buttonText.textContent = button.dataset.errorText || 'Error';
                    buttonText.style.display = 'inline';
                    loadingSpinner.style.display = 'none';
                    button.disabled = false;
                    
                    setTimeout(function() {
                        buttonText.textContent = button.dataset.addText || 'Add';
                    }, 2000);
                });
            });
        });
    }

});

// Cart drawer offer line (sections/mini-cart.liquid) opens the Klaviyo "Cart popup 15% Off" form. The drawer re-renders
// its contents on every cart change, so listen on the document.
// The form sits outside the drawer, so while it's open the drawer's focus trap is paused: otherwise a tap in the form
// counts as a click outside the drawer and closes it, and the email field can't take focus. Clicks outside close the
// drawer again once the form closes (or if it never opens).
var klaviyoPausedDrawer = null;
var klaviyoOpenTimeout = null;

function resumeKlaviyoPausedDrawer() {
  clearTimeout(klaviyoOpenTimeout);
  if (klaviyoPausedDrawer && klaviyoPausedDrawer.open) klaviyoPausedDrawer.focusTrap.unpause();
  klaviyoPausedDrawer = null;
}

document.addEventListener('click', function (event) {
  var button = event.target.closest && event.target.closest('[data-klaviyo-form]');
  if (!button) return;
  var drawer = button.closest('#mini-cart');
  if (drawer && drawer.focusTrap) {
    drawer.focusTrap.pause();
    klaviyoPausedDrawer = drawer;
    klaviyoOpenTimeout = setTimeout(resumeKlaviyoPausedDrawer, 3000);
  }
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', document.documentElement.getAttribute('data-cart-offer') || button.getAttribute('data-klaviyo-form')]);
});

// Which Klaviyo cart popup is live decides the offer line: its coupon's number is the percentage (CHECKOUT15 -> 15%),
// and the no-coupon form hides the line. Reads Klaviyo's public list of live forms (~5 KB, the file Klaviyo's own script
// loads) once per session, after the page has loaded. The result goes on <html> (data-cart-offer = form ID,
// --cart-offer-percent), so it survives the drawer re-rendering; custom-theme.css shows the line from it.
(function () {
  var STORAGE_KEY = 'hs-cart-offer';

  function apply(offer) {
    if (!offer || !offer.form) return;
    document.documentElement.setAttribute('data-cart-offer', offer.form);
    document.documentElement.style.setProperty('--cart-offer-percent', '"' + offer.percent + '%"');
  }

  function targetsCart(version) {
    return (version.trigger_groups || []).some(function (group) {
      return (group.triggers || []).some(function (trigger) {
        var whitelist = trigger.trigger_type === 'URL_PATH_PATTERNS' && trigger.data && trigger.data.value && trigger.data.value.whitelist;
        return Array.isArray(whitelist) && whitelist.some(function (path) { return path.indexOf('cart') !== -1; });
      });
    });
  }

  function findCoupon(node) {
    if (!node || typeof node !== 'object') return null;
    if (node.coupon_data && node.coupon_data.name) return node.coupon_data.name;
    for (var key in node) {
      var coupon = findCoupon(node[key]);
      if (coupon) return coupon;
    }
    return null;
  }

  function detect() {
    fetch('https://static-forms.klaviyo.com/forms/api/v7/XqYVbT/full-forms')
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var offer = { form: null };
        (data.full_forms || []).some(function (form) {
          return (form.live_form_versions || []).some(function (version) {
            if (version.form_type !== 'POPUP' || !targetsCart(version)) return false;
            var percent = (findCoupon(version) || '').match(/(\d+)$/);
            if (percent) offer = { form: form.form_id, percent: percent[1] };
            return true;
          });
        });
        try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(offer)); } catch (e) {}
        apply(offer);
      })
      .catch(function () {});
  }

  var cached = null;
  try { cached = JSON.parse(sessionStorage.getItem(STORAGE_KEY)); } catch (e) {}
  if (cached) return apply(cached);
  if (document.readyState === 'complete') setTimeout(detect, 1000);
  else window.addEventListener('load', function () { setTimeout(detect, 1000); });
})();

window.addEventListener('klaviyoForms', function (event) {
  if (!klaviyoPausedDrawer || !event.detail) return;
  if (event.detail.type === 'open') clearTimeout(klaviyoOpenTimeout);
  if (event.detail.type === 'close') {
    resumeKlaviyoPausedDrawer();
    // Signing up applies the form's discount code to the cart; re-render the drawer (theme.js CartDrawer fetches it
    // fresh when cart:refresh has no cart data) so its prices and total show the discount
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }
});

// Quick view Size buttons on swap products (snippets/product-form.liquid): load that size's quick view in place, the way
// the theme loads it on open (OpenableElement._load in theme.js).
document.addEventListener('click', function (event) {
  var button = event.target.closest && event.target.closest('[data-quick-buy-url]');
  if (!button || button.hasAttribute('aria-current') || button.hasAttribute('aria-busy')) return;
  var quickView = button.closest('quick-buy-drawer, quick-buy-popover');
  if (!quickView) return;

  button.setAttribute('aria-busy', 'true');
  fetch(button.getAttribute('data-quick-buy-url'))
    .then(function (response) { return response.text(); })
    .then(function (html) {
      var element = document.createElement('div');
      element.innerHTML = html;
      var content = element.querySelector(quickView.tagName.toLowerCase());
      if (!content) throw new Error('No quick view in response');
      quickView.innerHTML = content.innerHTML;
      // The theme keeps this image to swap it on variant change
      quickView.imageElement = quickView.querySelector('.quick-buy-product__image');
    })
    .catch(function () {
      button.removeAttribute('aria-busy');
    });
});

// Cart drawer "You may also like": the picture and name open the product's quick view (its Quick view button visible at
// this screen size) instead of the product page. One-variant products have no quick view, so they still link.
document.addEventListener('click', function (event) {
  var link = event.target.closest && event.target.closest('#mini-cart .mini-cart__recommendations .product-item a[href]');
  if (!link || link.closest('quick-buy-drawer, quick-buy-popover')) return;
  var item = link.closest('.product-item');
  var toggles = item.querySelectorAll('button[aria-controls$="-drawer"], button[aria-controls$="-popover"]');
  var toggle = Array.prototype.find.call(toggles, function (button) { return button.offsetParent !== null; });
  if (!toggle) return;
  event.preventDefault();
  toggle.click();
});
